import './DefaultError.less';

import React from 'react';
import AlertIcon from '../../../icons/svg/alert-icon-sv.svg';

function DefaultError({ text }) {
    return (
        <div className="default-error br-radius-xs px-10 py-10 c-black-50-2 flex items-start">
            <div>
                <AlertIcon />
            </div>
            <span className="pl-10 fs-14">{text}</span>
        </div>
    );
}

export default DefaultError;
